module.exports = __webpack_public_path__ + "static/media/btnEnd.5778080d.svg";